// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getStorage} from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHonwLwZdH_HbBVVRQkz2mm19bdrVMU0c",
  authDomain: "association-elwifak-bargou.firebaseapp.com",
  projectId: "association-elwifak-bargou",
  storageBucket: "association-elwifak-bargou.appspot.com",
  messagingSenderId: "258936636658",
  appId: "1:258936636658:web:ff7a835b6e027f02243c6b",
  measurementId: "G-VRMZJY5B99"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Authentication and Storage
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
